(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(pointer: fine)');

  const reveal = (scope = document) => {
    const elements = scope.querySelectorAll('[data-reveal]');
    if (!elements.length) return;
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    elements.forEach((element) => observer.observe(element));
  };

  const countdowns = (scope = document) => {
    scope.querySelectorAll('[data-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownReady === 'true') return;
      const launch = new Date(countdown.dataset.launchDate);
      if (Number.isNaN(launch.getTime())) return;
      countdown.dataset.countdownReady = 'true';
      let timer;
      const update = () => {
        const distance = Math.max(0, launch.getTime() - Date.now());
        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);
        const values = { days, hours, minutes, seconds };
        Object.entries(values).forEach(([key, value]) => {
          const target = countdown.querySelector(`[data-${key}]`);
          if (target) target.textContent = String(value).padStart(2, '0');
        });
        if (distance === 0 && timer) window.clearInterval(timer);
      };
      update();
      timer = window.setInterval(update, 1000);
    });
  };

  const depth = (scope = document) => {
    if (reducedMotion.matches || !finePointer.matches || document.body.dataset.motion !== 'true' || document.body.dataset.depth !== 'true') return;
    scope.querySelectorAll('[data-depth-scene]').forEach((scene) => {
      if (scene.dataset.depthReady === 'true') return;
      scene.dataset.depthReady = 'true';
      let frame;
      scene.addEventListener('pointermove', (event) => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => {
          const rect = scene.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
          const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
          scene.style.setProperty('--pointer-x', x.toFixed(3));
          scene.style.setProperty('--pointer-y', y.toFixed(3));
        });
      });
      scene.addEventListener('pointerleave', () => {
        scene.style.setProperty('--pointer-x', '0');
        scene.style.setProperty('--pointer-y', '0');
      });
    });
  };

  const videos = (scope = document) => {
    const candidates = scope.querySelectorAll('video[data-autoplay="true"]');
    if (!candidates.length || reducedMotion.matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.muted = true;
          const play = video.play();
          if (play) play.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '160px 0px', threshold: 0.35 });
    candidates.forEach((video) => observer.observe(video));
  };

  const init = (scope = document) => {
    reveal(scope);
    countdowns(scope);
    depth(scope);
    videos(scope);
  };

  document.documentElement.classList.add('k3d-js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
